import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";

const NotFound = lazy(() => import("./components/NotFound"));
const Adminpanel = lazy(() => import("./containers/AdminPanel"));
const AuthenticateScreen = lazy(() => import("./containers/AuthenticateScreen"));

export const AppRouter = () => (
    <Suspense
        fallback={
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: "100vh",
                    gap: 2,
                }}
            >
                <CircularProgress size={60} />
                <Typography variant="body2" color="text.secondary">
                    Please wait while we load your application
                </Typography>
            </Box>
        }
    >
        <Routes>
            <Route path="/" exact element={<AuthenticateScreen />} />
            <Route path="/authenticate" exact element={<AuthenticateScreen />} />
            <Route path="/admin-panel" exact element={<Adminpanel />} />

            <Route element={NotFound} />
        </Routes>
    </Suspense>
);
